import React from 'react'
import {Box, CircularProgress, Typography} from "@mui/material";

const UploadProgressIndication = ({progress}) => {

    // Source: https://mui.com/components/progress/
    return (
        <Box sx={{position: 'relative', display: 'inline-flex'}}>
            <CircularProgress color="inherit" variant="determinate" value={progress}/>
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div" color="white">
                    {`${Math.round(progress)}%`}
                </Typography>
            </Box>
        </Box>
    );
}
export default UploadProgressIndication
